import DashboardNew from '../DashboardNew';

const DashboardEditor = () => <DashboardNew />;

export default DashboardEditor;
